document.addEventListener('DOMContentLoaded', () => {
  // Forcing focus on mobile menu interaction as per ADA support
  const mobileMainMenu = document.querySelectorAll('ul.header-sidebar__linklist .header-sidebar__linklist-button');
  if (mobileMainMenu.length > 0) {
    mobileMainMenu.forEach(menuItem => {
      menuItem.addEventListener("click", (event) => {
        const ariaControlsAttr = event.currentTarget.getAttribute("aria-controls");
        if (!ariaControlsAttr) return;
        const ariaControl = document.querySelector(`[id^='${ariaControlsAttr}']`);
        const focusableElement = ariaControl && ariaControl.querySelector('.header-sidebar__back-button');
        if (!focusableElement) return;
        // Needs time out due to the transform duration
        setTimeout(() => {
          focusableElement.focus();
        }, 500);
      })
    })
  }
  
  // Sales Company Form Validator on force focus as per ADA support
  const salesCompanyForm = document.getElementById('contact_form');
  if (salesCompanyForm) {
    const submitBtn = salesCompanyForm.querySelector('button[type="submit"]');
    submitBtn.addEventListener('click', () => {
      const requiredElements = salesCompanyForm.querySelectorAll(':required');
      if (requiredElements.length > 0) {
        requiredElements[0].scrollIntoView();
        requiredElements.forEach((element) => {
          const hasError = !element.value;
          const hasErrorMsg = element.parentElement.querySelector('.text-error')
          if (hasError && !hasErrorMsg) {
            const invalidSpan = '{} is invalid';
            const msgElement = document.createElement('span')
            const msgContent = document.createTextNode(invalidSpan.replace('{}', element.placeholder));
            msgElement.className = "text-error form-error";
            msgElement.appendChild(msgContent);
            element.after(msgElement);
          } else if (!hasError && hasErrorMsg){
            hasErrorMsg.remove();
          }
        });
      };
    });

  }
  
  // Mobile Sub Menu close button as per ADA support
  const headerSideBar = document.querySelector('header-sidebar');
  const mobileSubMenuCloseBtn = document.querySelector('header-sidebar-collapsible-panel .header-sidebar__drawer button');
  if (mobileSubMenuCloseBtn && headerSideBar) {
    mobileSubMenuCloseBtn.addEventListener('click', () => {
      headerSideBar.hide();
    })
  }
  
});